import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import "antd/dist/antd.css";
import "../../css/users.css";
import { useLocation, useNavigate } from "react-router-dom";
import LeftSideNav from "../../components/LeftSideNav";
import { isPasswordValid } from "../../functions/commons";
import { isEmpty } from "lodash";
import { useResetPasswordMutation } from "../../store/appSlice";
import Navbar from "../../components/Navbar";

function ChangePassword() {
  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
    },
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [input, setInput] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);

  const [resetPassword] = useResetPasswordMutation();

  useEffect(() => {
    if (!isEmpty(errorMessage)) {
      setTimeout(() => {
        setErrorMessage("");
      }, 2000);
    }
  }, [errorMessage]);

  const validation = () => {
    const { newPassword, confirmPassword, currentPassword } = input;
    let currentPasswordError = "";
    let newPasswordError = "";
    let confirmPasswordError = "";

    let valid = true;
    if (isEmpty(currentPassword)) {
      valid = false;
      currentPasswordError = "Password cannot be empty";
    }
    if (isEmpty(newPassword)) {
      valid = false;
      newPasswordError = "Password cannot be empty";
    } else if (!isPasswordValid(newPassword)) {
      valid = false;
      newPasswordError =
        "Password must have 8 characters or more and include at least one lowercase letter, one uppercase letter, one digit, and one special character.";
    } else if (newPassword !== confirmPassword) {
      valid = false;
      confirmPasswordError = "Password is not same";
    }

    // one uppercase letter, one digit,one special character, and be at least 8 characters long.

    setError({
      ...error,
      currentPassword: currentPasswordError,
      newPassword: newPasswordError,
      confirmPassword: confirmPasswordError,
    });

    return valid;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput({
      ...input,
      [event.target.id]: event.target.value,
    });
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    if (validation()) {
      //   setLoading(true);
      //   const payload = {
      //     password: input.newPassword,
      //     uniqueKey: location.state.uniqueKey,
      //   };
      //   resetPassword(payload)
      //     .unwrap()
      //     .then((incomingData: any) => {
      //       setLoading(false);
      //       navigate("/auth/login", { replace: true });
      //     })
      //     .catch((err) => {
      //       setLoading(false);
      //       setErrorMessage(err?.data?.error?.message ?? "Something went wrong");
      //     });
    }
    console.log({ error });
  };

  const errorSec = (err: string) => (
    <div>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );

  const inputFormView = () => (
    <div>
      <div className="signin-form-div" style={{ paddingLeft: 140 }}>
        <h2>Change Password</h2>

        <Form {...layout} onFinish={handleSubmit} style={{ marginTop: 20 }}>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Current Password</h2>
          </div>
          <Form.Item name="newPassword">
            <Input.Password
              type="password"
              value={currentPassword}
              id="currentPassword"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.currentPassword) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.currentPassword) && errorSec(error.currentPassword)}
          </Form.Item>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>New Password</h2>
          </div>
          <Form.Item name="newPassword">
            <Input.Password
              type="password"
              value={newPassword}
              id="newPassword"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.newPassword) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.newPassword) && (
              <div style={{ width: "155%" }}>{errorSec(error.newPassword)}</div>
            )}
          </Form.Item>

          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Confirm Password</h2>
          </div>
          <Form.Item name="confirmPassword">
            <Input.Password
              type="password"
              value={confirmPassword}
              id="confirmPassword"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.confirmPassword) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.confirmPassword) && errorSec(error.confirmPassword)}
          </Form.Item>

          <Form.Item>
            <div style={{ marginTop: 20 }}>
              <Button type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );

  const { newPassword, confirmPassword, currentPassword } = input;
  return (
    <div className="profile__container">
      <Navbar />
      <div
        className="login_container"
        style={{
          backgroundColor: "white",
          width: "100vh",
          height: "85vh",
          marginTop: 90,
          boxShadow: "0px 3px 14px -3px rgba(0,0,0,0.73)",
          borderRadius: 20,
        }}
      >
        <div className="inputform_container">{inputFormView()}</div>
      </div>
    </div>
  );
}

export default ChangePassword;
